import React, { memo, useEffect, useState, useCallback } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ImageBackground,
  Dimensions,
  Modal,
  Image,
  StyleSheet,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { getAllOffersOnWa } from "../../services/api";

import { getItem, setItem } from "@lib/storage";
import CloseIcon from "@assets/svg/CloseIcon";
import Button from "@components/Button";
import { shareEntitiesOnWhatsApp } from "../../utils/shareEntity";

const { width: WIDTH } = Dimensions.get("window");

const AddOffersOnWA = memo(() => {
  const [data, setData] = useState({});

  const fetchOffers = useCallback(async () => {
    try {
      const { data: response } = await getAllOffersOnWa();
      setData(response);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    fetchOffers();
  }, [fetchOffers]);

  return <Banner {...data} />;
});

const Banner = (props) => {
  const {
    width = 1,
    height = 1,
    display_image = "",
    images = [],
    text = "",
    link = "",
  } = props;

  const [showInstructionsModal, setShowInstructionsModal] = useState(false);

  const aspectRatio = width / height;
  const widthMinusPadding = WIDTH - 40;
  const imageHeight = widthMinusPadding / aspectRatio;

  const shareEntitiesonWhatsapp = () => {
    shareEntitiesOnWhatsApp(text + " " + link, images);
  };

  const _onPress = async () => {
    try {
      const value = await getItem("shouldShowWaStoryShareIns");
      if (value) {
        shareEntitiesonWhatsapp();
      } else {
        setShowInstructionsModal(true);
        await setItem("shouldShowWaStoryShareIns", "true");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const addToStatusImg = require("@assets/images/addToStatus.webp");
  return (
    <>
      <View style={styles.container}>
        <TouchableOpacity
          onPress={_onPress}
          style={[styles.bannerStyles, { height: imageHeight }]}
        >
          <ImageBackground
            source={{
              uri: display_image,
            }}
            imageStyle={styles.bannerImage}
            style={{ height: imageHeight }}
          />
        </TouchableOpacity>
      </View>
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        visible={showInstructionsModal}
        onRequestClose={() => {
          setShowInstructionsModal(false);
        }}
      >
        <SafeAreaView style={styles.modalStyles} edges={["top", "bottom"]}>
          <TouchableOpacity
            hitSlop={{ top: 50, left: 50, right: 50, bottom: 50 }}
            onPress={() => {
              setShowInstructionsModal(false);
            }}
            style={styles.mbAuto}
          >
            <CloseIcon />
          </TouchableOpacity>

          <Text style={styles.textLine}>
            ऑफर्स को व्हाट्सऍप स्टेटस पर लगाने का तरीका
          </Text>
          <Image source={addToStatusImg} style={styles.addToStatusImg} />

          <Text style={styles.textLine2}>
            • अपने व्हाट्सऍप पर जाकर{" "}
            <Text style={styles.myStatus}>"My status"</Text> पर क्लिक करें I
          </Text>
          <Text style={styles.textLine3}>
            • उसके बाद व्हाट्सऍप पर दिए हुए स्टेप्स फॉलो करें I
          </Text>
          <Button
            buttonWidth={"100%"}
            btnText={"Continue"}
            onPress={() => {
              setShowInstructionsModal(false);
              shareEntitiesonWhatsapp();
            }}
            height={56}
            borderRadius={10}
            buttonStyle={styles.mb}
          />
        </SafeAreaView>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  container: { paddingVertical: 10 },
  bannerStyles: {
    paddingHorizontal: 15,
    borderRadius: 10,
  },
  bannerImage: { borderRadius: 10 },
  modalStyles: {
    flex: 1,
    backgroundColor: "white",
    paddingHorizontal: 15,
    justifyContent: "center",
  },
  mbAuto: { marginBottom: "auto" },
  myStatus: { fontWeight: "bold", padding: 69 },
  mb: {
    marginBottom: 20,
  },
  textLine: {
    fontSize: 20,
    fontWeight: "700",
    lineHeight: 28,
    textAlign: "center",
    marginBottom: 21,
  },
  addToStatusImg: {
    height: 225,
    width: "100%",
    marginBottom: 16,
  },
  textLine2: {
    fontSize: 16,
    lineHeight: 24,
  },
  textLine3: {
    fontSize: 16,
    lineHeight: 24,
    marginBottom: "auto",
  },
});
export default AddOffersOnWA;
